<!-- eslint-disable -->
<template lang="pug">
    .grade-form__container
        .grade-form
            .grade-form__title
                slot(name="title")
            form.grade-form__body(
                v-if="grade.status === 'active'"
                action="javascript://"
                @submit="submitForm"
            )
                .grade-form__field
                    .grade-form__label
                        | {{ $i18n.t('grade.grade_form_name') }}
                    .grade-form__field-body
                        cs-input.grade-form__input(
                            :error="errors.has('name')"
                            type="text"
                            v-model="gradeCopy.name"
                            name="name"
                            v-validate="'required'"
                            :data-vv-as="$i18n.t('grade.grade_form_nameVvSs')"
                        )
                        help-text(v-if="errors.has('name')" :error="errors.has('name')")
                            | {{ errors.first('name')}}
                .grade-form__field
                    .grade-form__label
                        | {{ $i18n.t('user.user_form_status') }}
                    .grade-form__field-body
                        cs-multiselect(
                            :multiple="false"
                            :options="statuses"
                            :show-labels="false"
                            :allow-empty="false"
                            :custom-label="getStatusName"
                            placeholder=""
                            v-model="gradeCopy.status"
                            :searchable="false"
                        )
                            span(slot="noResult")
                                | {{ $i18n.t('grade.grade_form_schoolNotFound') }}
                divider
                .grade-form__field
                    .grade-form__label
                        | {{ $i18n.t('grade.grade_form_parentSchool') }}
                    .grade-form__field-body
                        cs-multiselect(
                            :multiple="false"
                            :options="schools"
                            :show-labels="false"
                            :allow-empty="true"
                            :placeholder="$i18n.t('grade.grade_form_schoolPlaceholder')"
                            label="name"
                            :searchable="true"
                            :loading="loadingSchools"
                            @open="getSchools"
                            v-model="gradeCopy.school"
                            v-validate="'required'"
                            data-vv-value-path="innerValue"
                            data-vv-name="school"
                            :data-vv-as="$i18n.t('grade.grade_form_parentSchoolVvSs')"
                        )
                            span(slot="noResult")
                                | {{ $i18n.t('grade.grade_form_schoolNotFound') }}
                .grade-form__field
                    .grade-form__label
                        | {{ $i18n.t('grade.grade_form_location') }}
                    .grade-form__field-body
                        cs-multiselect(
                            :multiple="false"
                            :options="locations"
                            :show-labels="false"
                            :allow-empty="true"
                            :placeholder="locationsPlaceholder"
                            track-by="id"
                            :custom-label="getFullAddress"
                            v-model="gradeCopy.location"
                            :disabled="!gradeCopy.school || locations.length === 0"
                            v-validate="'required'"
                            data-vv-value-path="innerValue"
                            data-vv-name="location"
                            :data-vv-as="$i18n.t('grade.grade_form_locationVvSs')"
                        )
                            span(slot="noResult")
                                | {{ $i18n.t('grade.grade_form_locationNotFound') }}
                        help-text(v-if="errors.has('location')" :error="errors.has('location')")
                            | {{ errors.first('location')}}
                .grade-form__field
                    .grade-form__label
                        | {{ $i18n.t('grade.grade_form_teacher') }}
                    .grade-form__field-body
                        cs-multiselect(
                            :options="teachers"
                            :show-labels="false"
                            :hide-selected="true"
                            :placeholder="teachersPlaceholder"
                            :multiple="true"
                            :custom-label="getTeacherName"
                            track-by="id"
                            :loading="loadingTeachers"
                            v-model="gradeCopy.teachers"
                            v-validate="'required'"
                            :disabled="!gradeCopy.school || teachers.length === 0"
                            data-vv-value-path="innerValue"
                            data-vv-name="teachers"
                            :data-vv-as="$i18n.t('grade.grade_form_teacherVvSs')"
                        )
                            span(slot="noResult")
                                | {{ $i18n.t('grade.grade_form_schoolNotFound') }}
                            span(slot="maxElements")
                                | {{ $i18n.t('grade.grade_form_maxTeachers') }}
                        help-text(v-if="errors.has('teachers')" :error="errors.has('teachers')")
                            | {{ errors.first('teachers')}}
                .grade-form__field
                    .grade-form__label
                        | {{ $i18n.t('grade.grade_form_course') }}
                    .grade-form__field-body
                        cs-multiselect(
                            :multiple="false"
                            :options="courses"
                            :show-labels="false"
                            :allow-empty="true"
                            label="name"
                            track-by="id"
                            :searchable="true"
                            :loading="loadingCourses"
                            v-model="gradeCopy.course"
                            v-validate="'required'"
                            data-vv-value-path="innerValue"
                            data-vv-name="course"
                            :data-vv-as="$i18n.t('grade.grade_form_courseVvSs')"
                            :disabled="!gradeCopy.school || !courses.length"
                            :placeholder="coursesPlaceholder"
                        )
                            span(slot="noResult")
                                | {{ $i18n.t('grade.grade_form_schoolNotFound') }}
                        help-text(v-if="errors.has('course')" :error="errors.has('course')")
                            | {{ errors.first('course')}}
                .grade-form__field
                    .grade-form__label
                        | {{ $i18n.t('grade.grade_form_classes') }}
                    .grade-form__field-body.grade-form__field-body--inline
                        .date-selector
                            cs-datepicker(
                                :language="user.locale"
                                :disabled-dates="endDate ? {from: new Date(endDate)} : {}"
                                :value="startDate"
                                :format="customFormatter"
                                @input="startDate = dateToMoment($event, 'YYYY-MM-DDThh:mm:ss')"
                                v-validate="'date_format:YYYY-MM-DDThh:mm:ss|before:' + endDate  + ',true'"
                                :data-vv-as="$i18n.t('grade.grade_form_dateOfStartingVvSs')"
                                name="startDate"
                            )
                            help-text(v-if="endDate && errors.has('startDate') " :error="endDate && errors.has('startDate')")
                                | {{ errors.first('startDate')}}
                        div.date-divider —
                        .date-selector
                            cs-datepicker(
                                :language="user.locale"
                                :disabled-dates="startDate ? {to: new Date(startDate)} : {}"
                                :value="endDate"
                                :format="customFormatter"
                                @input="endDate = dateToMoment($event, 'YYYY-MM-DDThh:mm:ss')"
                                v-validate="'date_format:YYYY-MM-DDThh:mm:ss|after:' + startDate  + ',true'"
                                :data-vv-as="$i18n.t('grade.grade_form_dateOfFinishingVvSs')"
                                name="endDate"
                            )
                            help-text(v-if="startDate && errors.has('endDate')" :error="startDate && errors.has('endDate')")
                                | {{ errors.first('endDate')}}
                template(v-for="(lesson, index) in gradeCopy.timetable")
                    .grade-form__field
                        .grade-form__label
                            span(v-if="index === 0") {{ $i18n.t('grade.grade_form_classDays') }}
                        .grade-form__field-body.grade-form__field-body--inline
                            .day__selector
                                cs-multiselect(
                                    :multiple="false"
                                    :options="days"
                                    :show-labels="false"
                                    :custom-label="getDayOfWeek"
                                    :allow-empty="false"
                                    placeholder=""
                                    v-model="lesson.day"
                                )
                            .time
                                .time__input
                                    cs-input(
                                        type="text"
                                        :placeholder="$i18n.t('grade.grade_form_enterTimePlaceholder')"
                                        :value="lesson.time"
                                        @input="lesson.time = removeWhitespacesFromTime($event)"
                                        :name="'time' + index"
                                        v-validate="'timeIntervalFormat|timeInterval'"
                                        :data-vv-as="$i18n.t('grade.grade_form_timeVvSs')"
                                    )
                                    help-text(v-if="errors.has('time' + index)" :error="errors.has('time' + index)")
                                        | {{ errors.first('time' + index) }}
                                div(v-if="gradeCopy.timetable.length > 1")
                                    a.grade-form__link--close(
                                        href="javascript://"
                                        @click="removeLesson(index)",
                                        :title="$i18n.t('grade.grade_form_removeDayTitle')"
                                    )
                                        svg-icon(name="times", size="larges")
                .grade-form__field
                    .grade-form__label
                    .grade-form__field-body
                        a.grade-form__link(href="javascript://" @click="addDay")
                            | {{ $i18n.t('grade.grade_form_addClass') }}
                .grade-form__buttons
                    cs-button.grade-form__button(
                        color="blue"
                        pattern="primary-outline"
                        @click.prevent="$router.back()"
                    )
                        | {{ $i18n.t('common.common_button_cancel') }}
                    cs-button.grade-form__button(
                        color="blue"
                        type="submit"
                        :loading="isLoading"
                    )
                        slot(name="button")
            div(v-else) {{ $i18n.t('grade.grade_form_archivedEdit') }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash'
    import moment from 'moment'

    import CourseApi from '../../api/course'
    import UserApi from '../../api/user/user'
    import SchoolApi from '../../api/school'
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                days: _.range(1, 8),
                statuses: [
                    'active',
                    'archived'
                ],
                statusNames: {
                    active: this.$i18n.t('common.common_status_active'),
                    archived: this.$i18n.t('common.common_status_archived')
                },
                schools: [],
                locations: [],
                teachers: [],
                courses: [],
                gradeCopy: {},
                startDate: null,
                endDate: null,
                isLoading: false,
                loadingCourse: false,
                loadingSchools: false,
                loadingCourses: false,
                loadingTeachers: false
            }
        },
        props: {
            grade: Object,
            submit: Function
        },
        created() {
            this.gradeCopy = _.cloneDeep(this.grade);
            moment.locale(this.$i18n.locale);
            this.startDate = this.gradeCopy.startDate ? moment(this.gradeCopy.startDate).format('YYYY-MM-DDThh:mm:ss') : null;
            this.endDate = this.gradeCopy.endDate ? moment(this.gradeCopy.endDate).format('YYYY-MM-DDThh:mm:ss') : null;
            if (!this.gradeCopy.timetable) {
                this.gradeCopy.timetable = [];
            }
        },
        watch: {
            'grade.school': {
                handler(newSchool) {
                    this.gradeCopy.school = _.cloneDeep(newSchool);
                },
            },
            'gradeCopy.school': {
                handler(val, oldVal) {
                    if (!val || (val && oldVal && val.id !== oldVal.id)) {
                        this.gradeCopy.location = null;
                        this.gradeCopy.course = null;
                        this.gradeCopy.teachers = [];
                        this.courses = [];
                        this.teachers = [];
                        this.locations = [];
                    }
                    if (val) {
                        this.errors.remove('school');
                        val.locations && (this.locations = val.locations);
                        this.getTeachers();
                        this.getCourses();
                    }
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            removeWhitespacesFromTime (time) {
                return time.replace(/\s/g, "");
            },
            dateToMoment (date, format) {
                this.$nextTick(() => {
                    this.$validator.validate('startDate');
                    this.$validator.validate('endDate');
                })
                return moment(date).format(format);
            },
            addDay() {
                this.gradeCopy.timetable.push({
                    day: 1,
                    time: ''
                })
            },
            removeLesson(index) {
                this.gradeCopy.timetable.splice(index, 1);
            },
            getStatusName(status) {
                return this.statusNames[status];
            },
            getDayOfWeek(day) {
                return moment(day, 'E').format('dddd');
            },
            getTeacherName(teacher) {
                return `${teacher.firstName} ${teacher.lastName}`
            },
            submitForm() {
                this.$validator.validateAll()
                .then(() => {
                    if (!this.gradeCopy.school) {
                        this.errors.add('school', this.$i18n.t('grade.grade_form_schoolError'));
                    }
                    if (!this.errors.any()) {
                        if (this.startDate) {
                            this.gradeCopy.startDate = moment(this.startDate).format('YYYY-MM-DD');
                        } else {
                            this.gradeCopy.startDate = null;
                        }
                        if (this.endDate) {
                            this.gradeCopy.endDate = moment(this.endDate).format('YYYY-MM-DD');
                        } else {
                            this.gradeCopy.endDate = null;
                        }
                        this.isLoading = true;
                        this.submit(this.gradeCopy)
                        .then(grade => {
                            this.isLoading = false;
                            this.$router.push({name: "grade:profile", params: {id: grade.id}});
                        })
                        .catch((err) => {
                            if (err && err.response && err.response.data.errors) {
                                let errors = err.response.data.errors;
                                for (let field in errors) {
                                    if (errors.hasOwnProperty(field)) {
                                        errors[field].forEach((val) => {
                                            this.errors.add(field, val);
                                        });
                                    }
                                }
                            }
                            this.isLoading = false;
                        });
                    } else {
                        this.$toasted.error(this.$i18n.t('errors.fill_form'));
                    }
                })
                .catch(() => {
                    this.$toasted.error(this.$i18n.t('errors.fill_form'));
                });
            },
            getSchools() {
                if (this.schools.length) {
                    return;
                }
                this.loadingSchools = true;
                SchoolApi.list({
                    all: true,
                    withActiveAccount: true,
                }).then(data => {
                    let schools = data.schools;
                    this.schools = schools ? schools : [];
                    this.loadingSchools = false;
                }).catch(() => {
                    this.loadingSchools = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            getCourses () {
                this.loadingCourses = true;
                CourseApi.list({
                    schoolId: this.gradeCopy.school.id,
                    all: true
                }).then(data => {
                    let courses = data.courses;
                    this.courses = courses ? courses : [];
                    this.loadingCourses = false;
                }).catch(err => {
                    this.loadingCourses = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            getTeachers () {
                this.loadingTeachers = true;
                UserApi.list({
                    type: 'teacher',
                    schoolId: this.gradeCopy.school.id,
                    all: true
                }).then(data => {
                    let teachers = data.users;
                    this.teachers = teachers ? teachers : [];
                    this.loadingTeachers = false;
                }).catch(err => {
                    this.loadingTeachers = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            getFullAddress(location) {
                return `${location.city}, ${location.address}`
            },
            customFormatter(date, format = 'D MMM YYYY') {
                return moment(date).format(format);
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            locationsPlaceholder () {
                if (this.gradeCopy.school) {
                    if (this.locations.length) {
                        return this.$i18n.t('grade.grade_form_chooseLocation');
                    } else {
                        return this.$i18n.t('grade.grade_form_noAvailableLocations');
                    }
                } else {
                    return this.$i18n.t('grade.grade_form_chooseSchool');
                }
            },
            coursesPlaceholder () {
                if (this.gradeCopy.school) {
                    if (this.courses.length) {
                        return this.$i18n.t('grade.grade_form_chooseCourse');
                    } else {
                        return this.$i18n.t('grade.grade_form_noAvailableCourses');
                    }
                } else {
                    return this.$i18n.t('grade.grade_form_chooseSchool');
                }
            },
            teachersPlaceholder () {
                if (this.gradeCopy.school) {
                    if (this.teachers.length) {
                        return  this.$i18n.t('grade.grade_form_chooseTeacher');
                    } else {
                        return this.$i18n.t('grade.grade_form_noAvailableTeachers');
                    }
                } else {
                    return this.$i18n.t('grade.grade_form_chooseSchool');
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .grade-form__container {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        @include media($md) {
            padding: 30px;
        }
    }

    .grade-form {
        margin: 0;
        padding: 30px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    .grade-form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .grade-form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .grade-form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .grade-form__input {
        margin-bottom: 0;
    }

    .grade-form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            min-width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            width: 13em;
            min-width: 13em;
        }
    }

    .grade-form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .grade-form__field-body {
        flex-grow: 5;
    }

    .grade-form__field-body--inline {
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            align-items: baseline;
            flex-direction: row;
            flex: 1 0;
        }
    }

    .grade-form__field-body--bold {
        font-weight: 500;
    }

    .grade-form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .grade-form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .grade-form__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .grade-form__link--close {
        color: $hsl-color-blue-56;
        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .day__selector {
        width: 100%;
        margin-bottom: 20px;
        @include media($md) {
            margin: 0 30px 0 0;
        }
    }

    .time {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .time__input {
        width: 100%;
        &:not(:last-child) {
            margin-right: 10px;
        }
    }

    .date-selector {
        width: 100%;
    }

    .date-divider {
        width: 20px;
    }

    .date-selector:first-child {
        @include media($md) {
            margin-right: 20px;
        }
    }
    .date-selector:last-child {
        @include media($md) {
            margin-left: 20px;
        }
    }
</style>
